module.exports = __webpack_public_path__ + "img/wave_雙人合盤.9b922c0e.svg";